import * as React from 'react';
import {useState} from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  List,
  ListItem,
  ListItemIcon, ListItemText,
  Typography
} from "@mui/material";
import {Stack} from "@mui/system";
import MinnehahaSD from "../../images/menu/Minnehaha Sourdough.jpeg";
import NoFrillsSD from "../../images/menu/No Frills Sourdough.jpeg";
import RedWheatLove from "../../images/menu/Red Wheat Love.jpeg";
import GoldenGirl from "../../images/menu/Golden Girl.jpeg";
import OldGrainSD from "../../images/menu/Old Grain Sourdough.jpeg";
import ChocolateSD from "../../images/menu/Chocolate Sourdough.jpeg";
import ChocolateSD2 from "../../images/menu/Chocolate Sourdough2.jpeg";
import CinnaBom from "../../images/menu/Cinn-a-Bom.jpeg";
import Ciabatta from "../../images/menu/Ciabatta.jpeg";
import BeerInfusion from "../../images/menu/Beer Infusion.jpeg";
import JalapenoCheddar from "../../images/menu/Jalapeno Cheddar.jpeg";
import OliveHerb from "../../images/menu/Olive Herb.jpeg";
import SesameLoaf from "../../images/menu/Sesame Loaf.jpeg";
import SpeltMilk from "../../images/menu/Spelt Milk.jpeg";
import ToastedBarley from "../../images/menu/Toasted Barley.jpeg";
import SeededRedFife from "../../images/menu/Seeded Red Fife.jpeg";
import TrailMix from "../../images/menu/Trail Mix2.jpeg";
import Bagels from "../../images/menu/Bagels.jpeg";
import Bialys from "../../images/menu/Bialys.jpeg";
import Baguettes from "../../images/menu/Baguettes.jpeg";
import Focaccia from "../../images/menu/Focaccia-onion.jpeg";
import DanishRye from "../../images/menu/Danish Rye.jpeg";
import DanishRye2 from "../../images/menu/Danish Rye-2.jpeg";
import MeteilRye from "../../images/menu/Meteil Rye.jpeg";
import RyeTime from "../../images/menu/Rye Time.jpeg";
import SunnySesame from "../../images/menu/Sunny Sesame.jpeg";
import Farmhouse from "../../images/menu/Farmhouse v2.jpeg";
import Farmhouse2 from "../../images/menu/Farmhouse v2 crumb.jpeg";
import Rustique from "../../images/menu/Rustique.jpeg";
import Rustique2 from "../../images/menu/Rustique crumb.jpeg";
import Semolina from "../../images/menu/Semolina.jpeg";
import Semolina2 from "../../images/menu/Semolina-crumb.jpeg";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {MenuItemDialog} from "./MenuItemDialog";
import {MenuItemCard} from "./MenuItemCard";
import {
  bagelsDesc,
  baguettesDesc,
  beerInfusionDesc,
  bialysDesc, chocolateSdDesc,
  ciabattaDesc,
  cinnabomDesc,
  danishDesc,
  focacciaDesc,
  goldenGirlDesc,
  jalapenoCheddarDesc,
  meteilDesc,
  minnehahaSdDesc,
  noFrillsSdDesc,
  oldGrainSdDesc,
  oliveHerbDesc,
  redWheatLoveDesc,
  ryeTimeDesc,
  seededRedFifeDesc,
  sesameDesc,
  sunnySesameDesc,
  speltMilkDesc,
  toastedBarleyDesc,
  trailMixDesc, farmhouseDesc, rustiqueDesc, semolinaDesc
} from "./MenuItemDescriptions";
import {WheatIcon} from "../icon/WheatIcon";



function Menu(props) {
  const [menuItemDetail, setMenuItemDetail] = useState({title: undefined, content: undefined, img: undefined})
  const [openMenuItemDialog, setOpenMenuItemDialog] = useState(false)

  function openMenuItemPopup(title, content, img) {
    setMenuItemDetail({title: title, content: content, img: img})
    setOpenMenuItemDialog(true)
  }

  function onCloseMenuItemPopup() {
    setOpenMenuItemDialog(false)
    setMenuItemDetail({title: undefined, content: undefined, img: undefined})
  }

  return (
          <Grid container justifyContent={'center'} spacing={1} marginTop={2} marginBottom={1} paddingLeft={{xs: '5%', sm: '8%', md: '10%', lg: '30%'}} paddingRight={{xs: '5%', sm: '8%', md: '10%', lg: '30%'}}>
            <Typography align={'center'} fontSize={18}>
              Look for some of these items in upcoming <a href={'https://www.hotplate.com/minnehaha.bread'} target={'_blank'} rel="noreferrer">Hotplate</a> bread drops
            </Typography>
            <List sx={{marginLeft: '5%'}}>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                  Feel free to suggest styles or items you'd like to see in a drop
                </ListItemText>
              </ListItem>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                  All menu items use a sourdough levain (starter) and most use a long fermentation process
                </ListItemText>
              </ListItem>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{fontStyle: 'italic', fontSize: 14, marginLeft: -2}}>
                  A special bake order can be arranged, depending on size of the order and my availability.
                  See details in <a href={'/special'}>Special Orders</a>
                </ListItemText>
              </ListItem>
            </List>

            <Accordion>
              <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel2-content" id="panel2-header">
                <Typography component={'span'}>Classic Loaves</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1}>
                  <Stack direction={'row'} spacing={2} useFlexGap sx={{flexWrap: 'wrap'}}>
                    <MenuItemCard itemName={'Minnehaha Sourdough'} itemDescription={minnehahaSdDesc} openPopup={openMenuItemPopup} img1={MinnehahaSD}/>
                    <MenuItemCard itemName={'No Frills Sourdough'} itemDescription={noFrillsSdDesc} openPopup={openMenuItemPopup} img1={NoFrillsSD}/>
                    <MenuItemCard itemName={'Red Wheat Love'} itemDescription={redWheatLoveDesc} openPopup={openMenuItemPopup} img1={RedWheatLove}/>
                    <MenuItemCard itemName={'Golden Girl'} itemDescription={goldenGirlDesc} openPopup={openMenuItemPopup} img1={GoldenGirl}/>
                    <MenuItemCard itemName={'Old Grain Sourdough'} itemDescription={oldGrainSdDesc} openPopup={openMenuItemPopup} img1={OldGrainSD}/>
                    <MenuItemCard itemName={'Farmhouse'} itemDescription={farmhouseDesc} openPopup={openMenuItemPopup} img1={Farmhouse} img2={Farmhouse2}/>
                    <MenuItemCard itemName={'Rustique'} itemDescription={rustiqueDesc} openPopup={openMenuItemPopup} img1={Rustique} img2={Rustique2}/>
                    <MenuItemCard itemName={'Semolina'} itemDescription={semolinaDesc} openPopup={openMenuItemPopup} img1={Semolina} img2={Semolina2}/>
                  </Stack>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel2-content" id="panel2-header">
                <Typography component={'span'}>Flavor Enhanced</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction={'row'} spacing={1}>
                  <Stack direction={'row'} spacing={2} useFlexGap sx={{flexWrap: 'wrap'}}>
                    <MenuItemCard itemName={'Cinn-A-Bom'} itemDescription={cinnabomDesc} openPopup={openMenuItemPopup} img1={CinnaBom}/>
                    <MenuItemCard itemName={'Chocolate Sourdough'} itemDescription={chocolateSdDesc} openPopup={openMenuItemPopup} img1={ChocolateSD} img2={ChocolateSD2}/>
                    <MenuItemCard itemName={'Beer Infusion'} itemDescription={beerInfusionDesc} openPopup={openMenuItemPopup} img1={BeerInfusion}/>
                    <MenuItemCard itemName={'Jalapeño Cheddar'} itemDescription={jalapenoCheddarDesc} openPopup={openMenuItemPopup} img1={JalapenoCheddar}/>
                    <MenuItemCard itemName={'Olive & Herb'} itemDescription={oliveHerbDesc} openPopup={openMenuItemPopup} img1={OliveHerb}/>
                    <MenuItemCard itemName={'Sesame Loaf'} itemDescription={sesameDesc} openPopup={openMenuItemPopup} img1={SesameLoaf}/>
                    <MenuItemCard itemName={'Spelt Milk'} itemDescription={speltMilkDesc} openPopup={openMenuItemPopup} img1={SpeltMilk}/>
                    <MenuItemCard itemName={'Toasted Barley'} itemDescription={toastedBarleyDesc} openPopup={openMenuItemPopup} img1={ToastedBarley}/>
                    <MenuItemCard itemName={'Seeded Red Fife'} itemDescription={seededRedFifeDesc} openPopup={openMenuItemPopup} img1={SeededRedFife}/>
                    <MenuItemCard itemName={'Trail Mix'} itemDescription={trailMixDesc} openPopup={openMenuItemPopup} img1={TrailMix}/>
                    <MenuItemCard itemName={'Sunny Sesame'} itemDescription={sunnySesameDesc} openPopup={openMenuItemPopup} img1={SunnySesame}/>
                  </Stack>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel2-content" id="panel2-header">
                <Typography component={'span'}>Specialty Styles</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction={'row'} spacing={1}>
                  <Stack direction={'row'} spacing={2} useFlexGap sx={{flexWrap: 'wrap'}}>
                    <MenuItemCard itemName={'Bagels'} itemDescription={bagelsDesc} openPopup={openMenuItemPopup} img1={Bagels}/>
                    <MenuItemCard itemName={'Bialys'} itemDescription={bialysDesc} openPopup={openMenuItemPopup} img1={Bialys}/>
                    <MenuItemCard itemName={'Baguettes'} itemDescription={baguettesDesc} openPopup={openMenuItemPopup} img1={Baguettes}/>
                    <MenuItemCard itemName={'Focaccia'} itemDescription={focacciaDesc} openPopup={openMenuItemPopup} img1={Focaccia}/>
                    <MenuItemCard itemName={'Ciabatta'} itemDescription={ciabattaDesc} openPopup={openMenuItemPopup} img1={Ciabatta}/>
                  </Stack>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel2-content" id="panel2-header">
                <Typography>Rye</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction={'row'} spacing={1}>
                  <Stack direction={'row'} spacing={2} useFlexGap sx={{flexWrap: 'wrap'}}>
                    <MenuItemCard itemName={'Danish Rye'} itemDescription={danishDesc} openPopup={openMenuItemPopup} img1={DanishRye} img2={DanishRye2}/>
                    <MenuItemCard itemName={'Rye Time'} itemDescription={ryeTimeDesc} openPopup={openMenuItemPopup} img1={RyeTime}/>
                    <MenuItemCard itemName={'Metéil'} itemDescription={meteilDesc} openPopup={openMenuItemPopup} img1={MeteilRye}/>
                  </Stack>
                </Grid>
              </AccordionDetails>
            </Accordion>
            <MenuItemDialog isOpen={openMenuItemDialog} close={onCloseMenuItemPopup}
                            title={menuItemDetail.title} content={menuItemDetail.content} img={menuItemDetail.img}/>

          </Grid>
  )
}

export { Menu }